import React, {Component} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './main.scss';
import './mainBanners.scss';

const sliderSettings = {
  dots: true,
  arrows: false,
};

class MainBanners extends Component {
  render() {
    const {mainBanners} = this.props;
    return (
      <Slider className="main-carousel carousel" {...sliderSettings}>
        {mainBanners.map(mainBanner => {
          return (
            <div key={mainBanner.uid}>
              <a href={mainBanner.link.href} target="_self" title={mainBanner.title}>
                <div
                  className="slide-image"
                  style={{
                    backgroundImage: `url(${
                      mainBanner.imageurl.href ? mainBanner.imageurl.href : mainBanner.banner.url
                    })`,
                  }}
                >
                  <div className="slide-title">
                    <div>{mainBanner.tags.map(t => `#${t} `)}</div>
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </Slider>
    );
  }
}

export default MainBanners;
